export default {
      id: "icon-download-usage",
      viewBox: "0 0 12.5 19.25",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-download",
      toString: function () {
        return this.url;
      }
    }